import { DocumentTypes } from '../../Interfaces/Document';

export function getDocumentFormPlaceholdersByType(type: DocumentTypes) {
  switch (type) {
    case DocumentTypes.TEMPLATE:
      return {
        title: 'Template Name',
        titlePlaceholder: 'A template name to identify your template.',
        messagePlaceholder:
          'Add an optional message for all future documents created using this template.',
      };
    case DocumentTypes.FORM_REQUEST:
      return {
        title: 'Form Name',
        titlePlaceholder: 'A form name to identify your form.',
        messagePlaceholder:
          'Add an optional message for all future documents created using this form.',
      };
    default:
      return {
        title: 'Document Title',
        titlePlaceholder: 'A document title to identify your document.',
        messagePlaceholder: 'Add an optional message for the document signers.',
      };
  }
}
